import React from 'react'
import './HR.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Grid, Typography } from '@mui/material';
const NewEmployee = () => {
  // Fields Data
  const userInformation = [
    {
      label: "First Name:",
      placeholder: "First Name",
      outerMargin: 9,
      innerMargin: 5
    },
    {
      label: "Last Name:",
      placeholder: "Last Name",
      outerMargin: 9,
      innerMargin: 5
    },
    {
      label: "User Name:",
      placeholder: "user_name",
      outerMargin: 8.8,
      innerMargin: 4
    },
    {
      label: "Password:",
      placeholder: "At Least 8 Characters",
      outerMargin: 10.3,
      innerMargin: 5
    },
    {
      label: "Email:",
      placeholder: "abc@gmail.com",
      outerMargin: 14.5,
      innerMargin: 5
    },
  ]
  const addressInformation = [
    {
      label: "Street:",
      placeholder: "123 Main Street",
      outerMargin: 11,
      innerMargin: 5
    },
    {
      label: "City:",
      placeholder: "Karachi",
      outerMargin: 12,
      innerMargin: 12
    },
    {
      label: "State:",
      placeholder: "CA",
      outerMargin: 11,
      innerMargin: 9
    },
    {
      label: "Zip Code:",
      placeholder: "5555",
      outerMargin: 8,
      innerMargin: 5
    },
    {
      label: "Country:",
      placeholder: "Pakistan",
      outerMargin: 9,
      innerMargin: 5
    },
  ]
  const employeeInformation = [
    {
      label: "Joining Date",
      type: 'date',
      required: true,
      outerMargin: 8,
      isDropdown: false,
      innerMargin: 5,
    },
    {
      label: "Leave Date",
      type: 'date',
      required: false,
      outerMargin: 9.5,
      isDropdown: false,
      innerMargin: 6.5,
    },
    {
      label: "Employee ID",
      type: 'text',
      placeholder: 'OE-012',
      required: true,
      isDropdown: false,
      outerMargin: 8.5,
      innerMargin: 5,
    },
    {
      label: 'Blood Group',
      isDropdown: true,
      defaultValue: 'Select Blood Group',
      values: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
      outerMargin: 8.4
    },
    {
      label: 'Employee Status',
      isDropdown: true,
      defaultValue: 'Select Status',
      values: ['Intern', 'Permanent', 'Terminated'],
      outerMargin: 4.2
    },
    {
      label: 'Department',
      isDropdown: true,
      defaultValue: 'Select Department',
      values: ['Security', 'Purchasing', 'Quality Assurance', 'Customer Service'],
      outerMargin: 9
    },
    {
      label: 'Role',
      isDropdown: true,
      defaultValue: 'Select Role',
      values: ['Admin', 'Sanitary Staff', 'Developer', 'Receptionist'],
      outerMargin: 17
    },
    {
      label: 'Shift',
      isDropdown: true,
      defaultValue: 'Select Status',
      values: ['Morning', 'Afternoon', 'Night'],
      outerMargin: 17
    },
    {
      label: 'Leave Policy',
      isDropdown: true,
      defaultValue: 'Select Status',
      values: ['Policy 8-12', 'Policy 12-15', 'Policy 15-15'],
      outerMargin: 9
    },
    {
      label: 'Weekly Holiday',
      isDropdown: true,
      defaultValue: 'Select Status',
      values: ['Friday', 'Saturday', 'Sunday'],
      outerMargin: 6.3
    },

  ]
  const salaryInfo = [
    {
      label: 'Designation',
      required: true,
      isDropdown: true,
      defaultValue: 'Select Designation',
      values: ['CEO', 'CFO', 'COO', 'Manager'],
      outerMargin: 12
    },
    {
      label: "Designation Start Date",
      type: 'date',
      required: true,
      outerMargin: 2,
      isDropdown: false,
      innerMargin: 5,
    },
    {
      label: "Designation End Date",
      type: 'date',
      required: false,
      outerMargin: 3,
      isDropdown: false,
      innerMargin: 6.5,
    },
    {
      label: "Salary",
      type: 'text',
      placeholder: '50000',
      required: true,
      isDropdown: false,
      outerMargin: 17.7,
      innerMargin: 10,
    },
    {
      label: "Salary Start Date",
      type: 'date',
      required: true,
      outerMargin: 8,
      isDropdown: false,
      innerMargin: 5,
    },
    {
      label: "Salary End Date",
      type: 'date',
      required: false,
      outerMargin: 9.5,
      isDropdown: false,
      innerMargin: 6.5,
    },
    {
      label: "Salary Comment",
      type: 'text',
      placeholder: 'Type Here..',
      required: false,
      isDropdown: false,
      outerMargin: 8.5,
      innerMargin: 5,
    },
  ]
  return (
    <Box sx={{ height: '100%', backgroundColor: 'whitesmoke' }} >
      <Box sx={{ backgroundColor: 'white', borderRadius: 1.5, height: 70, mt: -4 }}>
        <Box sx={{ display: 'inline-flex', mt: 1.3, p: 1.2, px: 2.5 }} >
          <ArrowBackIcon sx={{ fontSize: 23, mt: 0.5 }} />
          <Typography style={{ marginLeft: 4, fontFamily: 'poppins', fontSize: 21, marginTop: 1.6 }} variant='h5'>Back</Typography>
        </Box>
      </Box>
      <Typography sx={{ textAlign: 'center', mt: 3, fontFamily: 'poppins', fontWeight: '600' }} variant='h5'>Add New Employee</Typography>
      <Box sx={{ backgroundColor: 'white', mt: 1.5, p: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} >
            <Typography style={{ fontSize: 20, marginLeft: -120, textAlign: 'center', fontFamily: 'poppins' }}>User Information</Typography>
            <Box sx={{ mb: 3 }}>
              {userInformation.map((x, i) => (
                <Box key={i} sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label}
                    <input style={{ marginLeft: x.innerMargin, width: 330, height: 35, border: 'solid 1px whitesmoke', fontSize: 15, borderRadius: 5, padding: 4, backgroundColor: 'whitesmoke', fontFamily: 'poppins' }} type='text' placeholder={x.placeholder} />
                  </Typography>
                </Box>))}
            </Box>
            <Typography style={{ fontSize: 20, marginLeft: -120, textAlign: 'center', fontFamily: 'poppins' }}>Employee Information</Typography>
            <Box>
              {employeeInformation.map((x, i) => (
                x.isDropdown ? <Box sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label} :
                    <select style={{ height: 35, borderRadius: 5, width: 330 }} name={x.label} id="dropdown">
                      <option selected disabled>{x.defaultValue}</option>
                      {x.values.map((value, index) => (<option key={index} value={value}>{value}</option>))}
                    </select>
                  </Typography>
                </Box> : <Box sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label} :
                    <input style={{ color: 'grey', marginLeft: x.innerMargin, width: 330, height: 35, border: 'solid 1px whitesmoke', fontSize: 15, borderRadius: 5, padding: 4, backgroundColor: 'whitesmoke', fontFamily: 'poppins' }} type={x.type} placeholder={x.placeholder ?? x.placeholder} />
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 20, textAlign: 'center', fontFamily: 'poppins' }}>Address Information</Typography>
            <Box sx={{ mb: 3 }}>
              {addressInformation.map((x, i) => (
                <Box sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label}
                    <input style={{ marginLeft: x.innerMargin, width: 330, height: 35, border: 'solid 1px whitesmoke', fontSize: 15, borderRadius: 5, padding: 4, backgroundColor: 'whitesmoke', fontFamily: 'poppins' }} type='text' placeholder={x.placeholder} />
                  </Typography>
                </Box>))}
            </Box>
            <Typography style={{ fontSize: 20, textAlign: 'center', fontFamily: 'poppins' }}>Designation & Salary Information</Typography>
            <Box>
              {salaryInfo.map((x, i) => (
                x.isDropdown ? <Box sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label} :
                    <select style={{ height: 35, borderRadius: 5, width: 330 }} name={x.label} id="dropdown">
                      <option selected disabled>{x.defaultValue}</option>
                      {x.values.map((value, index) => (<option key={index} value={value}>{value}</option>))}
                    </select>
                  </Typography>
                </Box> : <Box sx={{ marginLeft: x.outerMargin, fontFamily: 'poppins', mt: 1.5, display: 'flex', flexDirection: 'row' }}>
                  <Typography style={{ color: 'red', margin: 2 }}>*</Typography>
                  <Typography variant='p'>
                    {x.label} :
                    <input style={{ color: 'grey', marginLeft: x.innerMargin, width: 330, height: 35, border: 'solid 1px whitesmoke', fontSize: 15, borderRadius: 5, padding: 4, backgroundColor: 'whitesmoke', fontFamily: 'poppins' }} type={x.type} placeholder={x.placeholder ?? x.placeholder} />
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          <Button style={{ width: '50%', height: 40, fontFamily: 'poppins', backgroundColor: '#1890ff', color: 'white', margin: 'auto', marginTop: 80 }}>Add New Employee</Button>
        </Grid>
      </Box>
    </Box>

  )
}

export default NewEmployee